import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Link, Divider } from '@material-ui/core'
import ScrollAnimation from 'react-animate-on-scroll'
import 'animate.css/animate.min.css'
import Mcdonald from '../Img/mc.jpg'
import Drum from '../Img/drum.jpg'
import Editor from '../Img/editor.jpg'
import Sketch from '../Img/sketch.jpg'
import Violet from '../Img/violet.jpg'
import GitHubIcon from '@material-ui/icons/GitHub'
import {
  COLOR_FONT,
  COLOR_HIGH,
  COLOR_MID,
  SPACING_BIG,
  SPACING_MED,
  SPACING_XBIG,
  SPACING_SMALL,
  SPACING_XSMALL,
} from '../constants'
import Mp3 from '../Img/mp3.gif'

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: SPACING_MED,
    marginRight: SPACING_MED,
    marginBottom: SPACING_BIG,
    color: COLOR_FONT,
    [theme.breakpoints.up('md')]: {
      marginLeft: '15%',
      marginRight: '15%',
    },
  },
  title: {
    color: COLOR_HIGH,
    marginTop: SPACING_XBIG,
    paddingTop: SPACING_MED,
  },
  subtitle: {
    color: COLOR_MID,
    marginTop: SPACING_BIG,
    marginBottom: SPACING_XSMALL,
  },
  link: { color: COLOR_HIGH, marginRight: SPACING_XSMALL },
  desc: { marginBottom: SPACING_XSMALL, marginTop: '10px' },
  imgholder: {
    width: '100%',
    display: 'inline-block',
    marginTop: SPACING_SMALL,
    marginBottom: SPACING_XSMALL,
  },
  img: {
    maxWidth: '600px',
    width: '100%',
    height: 'auto',
  },
}))

function Contact() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography
          variant="h3"
          component="h3"
          className={classes.title}
          id={'fun'}
        >
          JUST FOR FUN
        </Typography>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Youtube MP3 downloader
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          July 2017
        </Typography>
        <Divider />
        <div className={classes.imgholder}>
          <img src={Mp3} alt={''} className={classes.img} />
        </div>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed desktop application with Electron JS and
          JavaScript
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Download audio of Youtube video and convert to MP3
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed and included built-in MP3 player
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Not working anymore as Youtube blocked the way to
          download the video / audio
        </Typography>
      </ScrollAnimation>

      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          McDonald's Kiosk using React
        </Typography>
        <Divider />
        <div className={classes.imgholder}>
          <img src={Mcdonald} alt={''} className={classes.img} />
        </div>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          Tried to imitate McDonald's Kiosk using React.js. It is possible to
          navigate menus and put it into your cart.
        </Typography>
        <Link
          href="https://ryanwlee.github.io/mcdonalds"
          className={classes.link}
        >
          DEMO
        </Link>
        <Link
          href="https://github.com/ryanwlee/mcdonalds"
          className={classes.link}
        >
          <GitHubIcon />
        </Link>
      </ScrollAnimation>
    </div>
  )
}

export default Contact
